// extracted by mini-css-extract-plugin
var _1 = "PdfViewerToolbarViewControlsTool-modulePdfViewerToolbarViewControlsTool__h5Evm PdfViewerToolbarButton-modulePdfViewerToolbarButton__zwwEi";
export { _1 as "PdfViewerToolbarViewControlsTool" }
